export const getAllTaxRule = (customTaxRules) => [
  ...(customTaxRules?.taxProducts ?? []),
  ...(customTaxRules?.taxSubCategories ?? []),
  ...(customTaxRules?.taxCategories ?? []),
  ...(customTaxRules?.taxTypes ?? []),
];
